import { post, get } from '../../../../services/request';

// Get all Read exam data
export const getAllExamDataRead = (payload) => {
    return post(`ExamData/GetAllReadDataWithPagination`, payload);
};

export const exportExamDataRead = (payload) => {
    const { fromDate, toDate, userId } = payload || {};
    if (!fromDate || !toDate) throw new Error('fromDate and toDate are required for Export Data');
    return get(`ExamData/ExportReadToCSV?FromDate=${fromDate}&ToDate=${toDate}`);
};
